angular.module("datasets")

    .controller("DatasetsListCtrl", ['datasetsService', 'LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state', 'logService',
        function (datasetsService, LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("DATASETS_WRITE");

            $rootScope.title = $filter('translate')('datasets.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('datasets.title') }
            ];

            $scope.gridOptions = {
                pdfTitle: $filter('translate')('datasets.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [20, 40, 60],
                paginationPageSize: 20,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                  { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                  { name: 'name', displayName: $filter('translate')('datasets.name'), enableFiltering: true, enableHiding: false },
                    {
                        name: 'is_system_dataset', displayName: $filter('translate')('general.is_system'), enableFiltering: true, enableHiding: false,
                        cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"text-align: center;\">" +
                            "<span ng-if=\"!row.entity.is_system_dataset\" class=\"label label-danger\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                            "<span ng-if=\"row.entity.is_system_dataset\" class=\"label label-primary\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                            "</div>"

                    },
                  {
                      name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                          { title: $filter('translate')('datasets.button_export'), action: 'ng-click="grid.appScope.exportDialog(row.entity.id)"', cssIconClass: "fa fa-gears" },
                          { title: $filter('translate')('datasets.button_edit'), action: 'ui-sref="datasets.edit({id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                          { title: $filter('translate')('datasets.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                      ], { cssClass: "pull-right" })
                  },
                ],
                getData: function (options) {
                    return Restangular.all('Datasets').getList(options);
                }
            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("datasets.edit", { id: rowEntity.id });
            };

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('datasets.button_delete'),
                    message: $filter('translate')('datasets.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Datasets', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('datasets.deleted_success'));
                            $scope.gridOptions.gridApi.core.raise.itemDeleted($scope);
                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });
            };

            $scope.exportDialog = function (id) {
                logService.debug("export", id);
                datasetsService.export(id, null);
            };

        }])

;